import type { WallSide, WindowShading } from "../types/C1_ModelTypes";

/** Shared shading indicator on the outside of windows and garden doors. */
export function C1_OpeningShading({ shading, centerX, centerY, length, thickness, horizontal, outwardSide,
  selected, indirectlySelected }: {
  shading: WindowShading; centerX: number; centerY: number; length: number; thickness: number;
  horizontal: boolean; outwardSide: WallSide; selected: boolean; indirectlySelected: boolean;
}) {
  if (shading === "none") return null;
  const offset = thickness / 2 + 5;
  const across = horizontal
    ? centerY + (outwardSide === "top" ? -offset : offset)
    : centerX + (outwardSide === "left" ? -offset : offset);
  return <line
    className="C1_svgOpeningShading"
    x1={horizontal ? centerX - length / 2 : across}
    y1={horizontal ? across : centerY - length / 2}
    x2={horizontal ? centerX + length / 2 : across}
    y2={horizontal ? across : centerY + length / 2}
    stroke={selected ? "#f59e0b" : indirectlySelected ? "#fdba74" : "#9ca3af"}
    strokeWidth={1.25}
    strokeDasharray={shading === "jalousie" ? "5 4" : undefined}
    pointerEvents="none"
  />;
}
